import { useMutation } from "@apollo/react-hooks"
import { useQueryData } from "utils"
import { GET_COMPANY, CREATE_COMPANY, UPDATE_COMPANY } from "../gql"

const useData = (objectId) => {
  const defaultData = {
    id: "",
    name: "",
    email: null,
    address: "",
    phoneNumber: "",
    companyNumber: "",
    area: ""
  }

  const { writeData, loading: queryLoading, data } = useQueryData(
    GET_COMPANY,
    {
      variables: { id: objectId },
      skip: !objectId,
      fetchPolicy: "cache-and-network"
    },
    { company: defaultData }
  )

  const [
    updateCompany,
    { loading: updateLoading, error: updateError }
  ] = useMutation(UPDATE_COMPANY)

  const [
    createCompany,
    { loading: createLoading, error: createError }
  ] = useMutation(CREATE_COMPANY)

  const getInputFromData = (localData) => {
    return {
      name: localData.name,
      email: localData.email,
      address: localData.address,
      phoneNumber: localData.phoneNumber,
      companyNumber: localData.companyNumber,
      area: localData.area
    }
  }

  const updateData = async (localData, callBack) => {
    await updateCompany({
      variables: {
        id: localData.id,
        input: getInputFromData(localData)
      }
    })
    if (callBack) callBack()
  }

  const createData = async (localData, callBack) => {
    await createCompany({
      variables: {
        input: getInputFromData(localData)
      }
    })
    if (callBack) callBack()
  }

  const checkRequire = (localData) => {
    return (
      localData?.name === "" ||
      localData?.area === "" ||
      localData?.address === "" ||
      localData?.companyNumber === "" ||
      localData?.phoneNumber === ""
    )
  }

  return {
    loading: updateLoading || createLoading || queryLoading,
    error: updateError || createError,
    createData,
    updateData,
    checkRequire,
    companyData: data?.company,
    writeData
  }
}

export default useData
